import React, { useState, useEffect, useContext, useRef} from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { AuthContext } from "../../Header/auth - context";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { Toast } from "primereact/toast";
import { InputTextarea } from 'primereact/inputtextarea';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputNumber } from 'primereact/inputnumber';
import CustomDropdown from '../../custom/customDropdown';
import './Ture.css';
import handlePrint from './naloziStrane/putniNalogStampa';

const PutniNalog = (props) => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const toast = useRef(null);

    /* Zaključana tura (obračunata) ne prima izmene — brana je u bazi, u dvanaest
       procedura. Forma to mora da zna unapred: inače korisnik popuni polja pa
       tek na snimanju sazna da ništa od toga neće proći. */
    const [zakljucana, setZakljucana] = useState(false);
    const [otkljucavam, setOtkljucavam] = useState(false);
    const dispatch = useDispatch();
    const trip = useSelector(state => state.trip)
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const [izabran, setIzabran] = useState(false)
    const [vozilaOptions, setVozilaOptions] = useState([])
    const [zamenskaVozilaOptions, setZamenskaVozilaOptions] = useState([])
    const [prikljucnaVozilaOptions, setPrikljucnaVozilaOptions] = useState([])
    const [vozaciOptions, setVozaciOptions] = useState([])
    const [vozaciZamenskiOptions, setVozaciZamenskiOptions] = useState([])
    const [statusTureOptions, setStatusTureOptions] = useState([])
    const [obracunTureOptions, setObracunTureOptions] = useState([])
    const [porukaTimeRange, setPorukeTimeRange] = useState(null)
    const [porukaTimeRange2, setPorukeTimeRange2] = useState(null)
    const [porukaVozilo, setPorukeVozilo] = useState(null)

    const [changeView, setChangeView] = useState(1);
    const activeClass = 'activeButton'

    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
        const addDriver = () => {
            if(formDataTripLog.ostaliVozaci.length < 3){
                 setFormDataTripLog(prev => ({
                ...prev,
                ostaliVozaci: [...prev.ostaliVozaci, null] // null za novog vozača dok se ne izabere
            }));
            }
        };

        const removeDriver = (index) => {
            setFormDataTripLog(prev => ({
                ...prev,
                ostaliVozaci: prev.ostaliVozaci.filter((_, i) => i !== index)
            }));
        };

        const addVehicle = () => {
            if(formDataTripLog.ostalaVozila.length < 3){
                 setFormDataTripLog(prev => ({
                ...prev,
                ostalaVozila: [...prev.ostalaVozila, null] // null za novog vozača dok se ne izabere
            }));
            }
        };

        const removeVehicle = (index) => {
            setFormDataTripLog(prev => ({
                ...prev,
                ostalaVozila: prev.ostalaVozila.filter((_, i) => i !== index)
            }));
        };
    
     useEffect(()=>{
        if(trip !=null){
            popuniRedove()
            setIzabran(true)
        } else {
             setIzabran(false)
        }
        
          },[trip])

///DATA

    const [formDataTripLog, setFormDataTripLog] = useState({
        // Personal Data
        brojPutnogNaloga: '',
        datumPolaska: null,
        datumDolaska: null, 
        relacija: '',
        napomenaPutniNalog: '',
        vozilo: null,
        ostalaVozila: [],
        prikljucnoVozilo: null,
        vozac: null,
        ostaliVozaci: [],
        statusTure: null,
        obracunTure: null,
        datumObracuna: null,
        //vucno
        pocetnaKM: null,
        zavrsnaKM: null,
        razlikaKM: null,
        pocetnoStanjeGoriva: null,
        zavrsnoStanjeGoriva: null,
        potrosenoGorivo: null,
        prosecnaPotrosnja: null,
        //TK
        pocetniSatiTK: null,
        zavrsniSatiTK: null,
        razlikaSatiTK: null,
        pocetnoStanjeGorivaTK: null,
        zavrsnoStanjeGorivaTK: null,
        potrosenoGorivoTK: null,
        //Adblue
        pocetnaKMAdblue: null,
        zavrsnaKMAdblue: null,
        razlikaKMAdblue: null,
        pocetnoStanjeAdBlue: null,
        zavrsnoStanjeAdBlue: null,
        potrosenAdBlue: null
    });


   useEffect(()=>{
        if(trip == null){
        resetData()
    }
   },[trip])

    useEffect(()=>{
         let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: trip ?? null
                            }),
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/trip", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setVozilaOptions(parsedData.VozniParkDB)
                                setZamenskaVozilaOptions(parsedData.ZamenskiVozniParkDB)
                                setPrikljucnaVozilaOptions(parsedData.VozniParkPrikljucnaDB)
                                setVozaciOptions(parsedData.VozaciDB)
                                setVozaciZamenskiOptions(parsedData.VozaciZamenskiDB)
                                setStatusTureOptions(parsedData.StatusTure)
                                setObracunTureOptions(parsedData.ObracunTure)
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    },[formSubmitted])

    const handleChange = (e, index) => {
    const { name, value } = e.target || e; // ako Dropdown šalje samo value

    if (name === "ostaliVozaci") {
        setFormDataTripLog(prev => {
            const updated = [...prev.ostaliVozaci];
            updated[index] = value; // menjamo samo tog vozača
            return { ...prev, ostaliVozaci: updated };
        });

    } else if  (name === "ostalaVozila") {
        console.log(value)
                    if(formDataTripLog.vozilo != value) {
                        if(value != null) {
                            let same = false;
                            for(let i = 0; i < formDataTripLog.ostalaVozila.length; i++) {
                                    if(i !== index && formDataTripLog.ostalaVozila[i] == value)
                                    same = true;
                            }
                            if(same){
                             setFormDataTripLog(prev => {
                                    const updated = [...prev.ostalaVozila];
                                    updated[index] = null;
                                    return { ...prev, ostalaVozila: updated };
                                })
                            setPorukeVozilo('Vozilo i vozila iz grupe dodatnih ne smeju biti ista!')
                            return
                            } else {
                                if(porukaVozilo != null)
                                setPorukeVozilo(null)
                            }
                        }
                    } else  if (formDataTripLog.vozilo && formDataTripLog.vozilo == value){
                          setFormDataTripLog(prev => {
                                const updated = [...prev.ostalaVozila];
                                updated[index] = null;
                                return { ...prev, ostalaVozila: updated };
                            }) 
                        setPorukeVozilo('Vozilo i dodatna vozila ne mogu biti ista!')
                        return    
                    }
                    
        setFormDataTripLog(prev => {
            const updated = [...prev.ostalaVozila];
            updated[index] = value ?? null; // menjamo samo tog vozača
            return { ...prev, ostalaVozila: updated };
        })
    } else if (name in formDataTripLog) {
         if(name === 'datumDolaska' && formDataTripLog.datumPolaska != null && (formDataTripLog.datumPolaska >= value)) {
                setFormDataTripLog(prev => ({ ...prev, datumDolaska: null }));
                setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                return
            } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
            }
             if(name === 'datumObracuna' && formDataTripLog.datumDolaska == null) {
                setFormDataTripLog(prev => ({ ...prev, datumObracuna: null }));
                setPorukeTimeRange2('Datum obračuna ne može biti unet pre završetka ture! Uneti datum dolaska!')
                return
            } else if (name === 'datumObracuna' && formDataTripLog.datumDolaska != null && formDataTripLog.datumDolaska > value) {
                setFormDataTripLog(prev => ({ ...prev, datumObracuna: null }));
                setPorukeTimeRange2('Datum dolaska ne može biti veći od datuma obračuna!')
                return
            } else {
                if(porukaTimeRange2 != null)
                    setPorukeTimeRange2(null)
            }
           if(name === 'zavrsnaKM' && formDataTripLog.pocetnaKM != null && (formDataTripLog.pocetnaKM < value)) {
                setFormDataTripLog(prev => ({ ...prev, razlikaKM: value - formDataTripLog.pocetnaKM}));
                setFormDataTripLog(prev => ({ ...prev, zavrsnaKM: value }));
                return
            } else if(name === 'zavrsnaKM' && !formDataTripLog.pocetnaKM  && !value) {
                setFormDataTripLog(prev => ({ ...prev, razlikaKM: null}));  
                setFormDataTripLog(prev => ({ ...prev, zavrsnaKM: value }));
            } else if(name === 'pocetnaKM' && !formDataTripLog.zavrsnaKM  && !value) {
                setFormDataTripLog(prev => ({ ...prev, razlikaKM: null}));  
                setFormDataTripLog(prev => ({ ...prev, pocetnaKM: value }));
            } else if(name === 'zavrsnaKM' && formDataTripLog.pocetnaKM != null && (formDataTripLog.pocetnaKM >= value)) {
                setFormDataTripLog(prev => ({ ...prev, zavrsnaKM: null }));
                setFormDataTripLog(prev => ({ ...prev, razlikaKM: null }));
                return
            } else if(name === 'zavrsniSatiTK' && formDataTripLog.pocetniSatiTK != null && (formDataTripLog.pocetniSatiTK < value)) {
                setFormDataTripLog(prev => ({ ...prev, zavrsniSatiTK: value }));
                setFormDataTripLog(prev => ({ ...prev, razlikaSatiTK: value - formDataTripLog.pocetniSatiTK}));
                return
            } else if(name === 'zavrsniSatiTK' && formDataTripLog.pocetniSatiTK != null && (formDataTripLog.pocetniSatiTK >= value)) {
                setFormDataTripLog(prev => ({ ...prev, zavrsniSatiTK: null }));
                setFormDataTripLog(prev => ({ ...prev, razlikaSatiTK: null }));
                return
            } else if(name === 'zavrsnaKMAdblue' && formDataTripLog.pocetnaKMAdblue != null && (formDataTripLog.pocetnaKMAdblue < value)) {
                setFormDataTripLog(prev => ({ ...prev, zavrsnaKMAdblue: value }));
                setFormDataTripLog(prev => ({ ...prev, razlikaKMAdblue: value - formDataTripLog.pocetnaKMAdblue}));
                return
            } else if(name === 'zavrsnaKMAdblue' && formDataTripLog.pocetniSatiTK != null && (formDataTripLog.pocetnaKMAdblue >= value)) {
                setFormDataTripLog(prev => ({ ...prev, zavrsnaKMAdblue: null }));
                setFormDataTripLog(prev => ({ ...prev, razlikaKMAdblue: null }));
                return
            } else if(name === 'potrosenoGorivo' && formDataTripLog.razlikaKM != null) {
                let  prosPotrosnja = (formDataTripLog.potrosenoGorivo * 100) / formDataTripLog.razlikaKM
                setFormDataTripLog(prev => ({ ...prev, ["prosecnaPotrosnja"]: prosPotrosnja}));
                return
            } else {
                if(name === 'vozilo' && formDataTripLog.ostalaVozila != null && formDataTripLog.ostalaVozila.length > 0){
                    let same = false;
                    for(let i = 0; i < formDataTripLog.ostalaVozila.length; i++) {
                            if(formDataTripLog.ostalaVozila[i] == value)
                            same = true;
                    }
                    if(same){
                    setFormDataTripLog(prev => ({ ...prev, vozilo: null }));
                    setPorukeVozilo('Vozilo i dodatna vozila ne mogu biti ista!')
                    return
                    } else {
                        if(porukaVozilo != null)
                        setPorukeVozilo(null)
                    }
                } 

                setFormDataTripLog(prev => ({ ...prev, [name]: value }));
            }
  
    }
};
    

    const popuniStavke = (apiData) => {

    /* Procedura vraća 1 kad je tura obračunata — vidi trip.TuraZakljucana. */
    setZakljucana(Number(apiData[0]?.zakljucana) === 1);

    setFormDataTripLog({
        brojPutnogNaloga: apiData[0].ID || '',
        datumPolaska: apiData[0].datumPolaska ? new Date(apiData[0].datumPolaska) : null,
        datumDolaska: apiData[0].datumDolaska ? new Date(apiData[0].datumDolaska) : null,
        relacija: apiData[0].relacija || '',
        napomenaPutniNalog: apiData[0].napomenaPutniNalog || '',
        vozilo:  apiData[0].vozilo || null,
        ostalaVozila: apiData[0].ostalaVozila ? JSON.parse(apiData[0].ostalaVozila) : [],
        prikljucnoVozilo:  apiData[0].prikljucnoVozilo || null,
        vozac:  apiData[0].vozac || null,
        ostaliVozaci: apiData[0].ostaliVozaci ? JSON.parse(apiData[0].ostaliVozaci) : [],
        statusTure: parseInt(apiData[0].statusTure?.toString()) || null,
        obracunTure: parseInt(apiData[0].obracunTure?.toString()) || null,
        datumObracuna: apiData[0].datumObracuna ? new Date(apiData[0].datumObracuna) : null,
        pocetnaKM: apiData[0].pocetnaKM || null,
        zavrsnaKM: apiData[0].zavrsnaKM || null,
        razlikaKM: apiData[0].razlikaKM || null,
        pocetnoStanjeGoriva: apiData[0].pocetnoStanjeGoriva || null,
        zavrsnoStanjeGoriva: apiData[0].zavrsnoStanjeGoriva || null,
        potrosenoGorivo: apiData[0].potrosenoGorivo || null,
        prosecnaPotrosnja: apiData[0].prosecnaPotrosnja || null,
        pocetniSatiTK: apiData[0].pocetniSatiTK || null,
        zavrsniSatiTK: apiData[0].zavrsniSatiTK || null,
        razlikaSatiTK: apiData[0].razlikaSatiTK || null,
        pocetnoStanjeGorivaTK: apiData[0].pocetnoStanjeGorivaTK || null,
        zavrsnoStanjeGorivaTK: apiData[0].zavrsnoStanjeGorivaTK || null,
        potrosenoGorivoTK: apiData[0].potrosenoGorivoTK || null,
        pocetnaKMAdblue: apiData[0].pocetnaKMAdblue || null,
        zavrsnaKMAdblue: apiData[0].zavrsnaKMAdblue || null,
        razlikaKMAdblue: apiData[0].razlikaKMAdblue || null,
        pocetnoStanjeAdBlue: apiData[0].pocetnoStanjeAdBlue || null,
        zavrsnoStanjeAdBlue: apiData[0].zavrsnoStanjeAdBlue || null,
        potrosenAdBlue: apiData[0].potrosenAdBlue || null
    });
};

    /* Otključavanje traži potvrdu: vraća u rad turu po kojoj je možda već
       plaćeno. Dugme postoji samo kad je tura stvarno zaključana — trajno
       vidljivo dugme „otključaj" poziva da se koristi i kad ne treba. */
    const otkljucaj = () => {
        confirmDialog({
            group: 'putniNalog',
            message: t('ture.otkljucajNapomena'),
            header: t('ture.otkljucajPotvrda'),
            icon: 'pi pi-unlock',
            acceptLabel: t('ture.otkljucaj'),
            rejectLabel: t('common.otkazi'),
            acceptClassName: 'p-button-danger',
            accept: () => {
                setOtkljucavam(true);
                fetch(process.env.REACT_APP_BACKEND_URL + '/trip/OtkljucajTuru', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
                    body: JSON.stringify({ id: trip }),
                })
                    .then(r => (r.ok ? r.json() : Promise.reject(r)))
                    .then(d => {
                        toast.current?.show({
                            severity: d?.ID ? 'success' : 'warn',
                            summary: d?.ID ? t('common.uspeh') : t('common.upozorenje'),
                            detail: d?.message || '', life: 5000,
                        });
                        /* Stanje se ne pogađa nego se forma ponovo učita — tako se
                           vidi tačno ono što je u bazi posle otključavanja. */
                        if (d?.ID) popuniRedove();
                    })
                    .catch(async (e) => {
                        const m = e?.json ? await e.json().catch(() => ({})) : {};
                        toast.current?.show({
                            severity: 'error', summary: t('common.greska'),
                            detail: m.message || t('common.greska'), life: 5000,
                        });
                    })
                    .finally(() => setOtkljucavam(false));
            },
        });
    };

    const popuniRedove = async () => {
    
        if(!trip) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali putni nalog da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: trip
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/FillInTripData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                      
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka putnog naloga!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

const resetData = ()=> {
    /* Nova (prazna) tura nikad nije zaključana — bez ovoga bi traka ostala na
       ekranu posle prelaska sa obračunate ture na unos nove. */
    setZakljucana(false);
    setFormDataTripLog({
        brojPutnogNaloga: '',
        datumPolaska: null,
        datumDolaska: null, 
        relacija: '',
        napomenaPutniNalog: '',
        vozilo: null,
        ostalaVozila: [],
        prikljucnoVozilo: null,
        vozac: null,
        ostaliVozaci: [],
        statusTure: null,
        obracunTure: null,
        datumObracuna: null,
        pocetnaKM: null,
        zavrsnaKM: null,
        razlikaKM: null,
        pocetnoStanjeGoriva: null,
        zavrsnoStanjeGoriva: null,
        potrosenoGorivo: null,
        prosecnaPotrosnja: null,
        pocetniSatiTK: null,
        zavrsniSatiTK: null,
        razlikaSatiTK: null,
        pocetnoStanjeGorivaTK: null,
        zavrsnoStanjeGorivaTK: null,
        potrosenoGorivoTK: null,
        pocetnaKMAdblue: null,
        zavrsnaKMAdblue: null,
        razlikaKMAdblue: null,
        pocetnoStanjeAdBlue: null,
        zavrsnoStanjeAdBlue: null,
        potrosenAdBlue: null
    });
}

 const handleFormSubmit = (e) => {

            e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    handleUploadAndSave()
 }
        const handleUploadAndSave = () => {
       
            confirmDialog({
            group: 'putniNalog',
            message: "Jel ste sigurni da želite nastaviti sa unosom?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptInsert,
            reject: rejectInsert,
            });
            //FILES

    };

    function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

    const acceptInsert = async () => {

            //DATA
                const hasAnyValueTripLog = Object.values(formDataTripLog).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
       
            if(izabran && trip){
                 if(hasAnyValueTripLog){

                      const payload = {
                        ...formDataTripLog,
                        datumPolaska: toUtcIso(formDataTripLog.datumPolaska),
                        datumDolaska: toUtcIso(formDataTripLog.datumDolaska),
                        datumObracuna: toUtcIso(formDataTripLog.datumObracuna)
                        };
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: trip,
                                formDataTripLog: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/UpdateTrip", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima putnog naloga.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima putnog naloga.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka putnog naloga!",
                                life: 3000,
                                });
                                
                                setFormSubmitted(false)
                                /* Posle izmene nalog ostaje izabran i u radu */

                               }
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke putnog naloga za unos!",
                        life: 3000,
                    });
                }
           
           
            } else {

                if(hasAnyValueTripLog){
                

                    /* Podrazumevani status se uzima iz PRVE stavke šifarnika, ne iz
                       zakucanog broja. Šifre su `IDENTITY` po bazi i razlikuju se od
                       baze do baze — grupa 20 je 16.10.2026 na lokalu 499–509 a na
                       produkciji 496–506. Zakucan broj je tačan tačno na jednoj bazi.

                       Broj ostaje kao poslednja odbrana ako spisak nije stigao: oba
                       polja su u bazi NOT NULL, pa bi `null` obio INSERT porukom
                       „Cannot insert the value NULL". */
                    const payload = {
                        ...formDataTripLog,
                        statusTure: formDataTripLog.statusTure != null
                            ? formDataTripLog.statusTure : (statusTureOptions?.[0]?.value ?? 144),
                        obracunTure: formDataTripLog.obracunTure != null
                            ? formDataTripLog.obracunTure : (obracunTureOptions?.[0]?.value ?? 147),
                        datumPolaska: toUtcIso(formDataTripLog.datumPolaska),
                        datumDolaska: toUtcIso(formDataTripLog.datumDolaska),
                        datumObracuna: toUtcIso(formDataTripLog.datumObracuna)
                        };
                
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formDataTripLog: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/InsertTrip", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                } 
                                props.setResetOnSubmit(!props.resetOnSubmit)
                                /* Backend vraća "id" malim slovima — sa data.ID
                                   je u store išlo undefined, pa novi nalog nije
                                   postajao aktivan i forma je ostajala prazna. */
                                dispatch({
                                    type: "TRIP",
                                    value: data.id
                                });
                                setFormSubmitted(false)
                                /* Forma se NE prazni — effect na [trip] odmah
                                   povlači novi nalog iz baze i on ostaje u radu
                                   (dobija i broj naloga koji dodeljuje procedura). */

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka putnog naloga!",
                                life: 3000,
                                });

                                if(data.alarmUpozorenje){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: "Upozorenje - dokumentacija vozila!",
                                    detail: data.alarmUpozorenje,
                                    life: 8000,
                                    });
                                }

                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke putnog naloga za unos!",
                        life: 3000,
                    });
                }
            }

  };
    const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };     
 




const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};

// const handleCancel = () => {
//     console.log('Korisnik je odbio stampu.');
//     setOpenModal(false);
//   };

// const handleConfirm = () => {
//     console.log('Korisnik je prihvatio stampu.');
//     //generatePDF()
//     // Ovde dodaj logiku za štampanje
//     setOpenModal(false);
//   };



    return (
        <div className="p-fluid grid formUnosZap">
            <Toast ref={toast} />
            <ConfirmDialog group="putniNalog" />

            {/* Traka stoji IZNAD forme, ne uz dugme za snimanje: korisnik treba da
                zna da su izmene zatvorene PRE nego što popuni polja, a ne kad
                pritisne „Sačuvaj". */}
            {zakljucana && (
                <div className="pn-zakljucana">
                    <i className="pi pi-lock" />
                    <span>{t('ture.zakljucanaTura')}</span>
                    <Button type="button" icon="pi pi-unlock" severity="danger" size="small" outlined
                            label={t('ture.otkljucaj')} disabled={otkljucavam}
                            onClick={otkljucaj} />
                </div>
            )}
           
            <form autoComplete="off" ref={formRef}>
                <div className="col-12 md:col-6">
                    <Card className='cardTripLog'>
                        <div className="gridPutniNalog">
                            <div className="col-12 md:col-6">
                                <label htmlFor="brojPutnogNaloga">{t('ture.brojPutnog')}:</label>
                                <InputText
                                    id="brojPutnogNaloga" disabled 
                                    name="brojPutnogNaloga" value={formDataTripLog.brojPutnogNaloga}
                                />
                                
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumPolaska">{t('ture.datumPolaska')}:</label>
                                <Calendar required mask="99.99.9999 99:99" invalid={invalidControl(formDataTripLog.datumPolaska)} id="datumPolaska" name="datumPolaska" value={formDataTripLog.datumPolaska} onChange={handleChange} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumDolaska">{t('ture.datumDolaska')}:</label>
                                {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                <Calendar mask="99.99.9999 99:99" id="datumDolaska" name="datumDolaska" value={formDataTripLog.datumDolaska} onChange={handleChange} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24"/>
                            </div>
                             <div className="col-12 md:col-6">
                                <label htmlFor="relacija">{t('nova.relacija')}:</label>
                                <InputText readOnly className="poljeIzracunato" value={formDataTripLog.relacija} id="relacija" name="relacija"/>
                            </div>
                             <div className="col-12">
                                <label htmlFor="napomenaPutniNalog">{t('nova.napomena')}:</label>
                                <InputTextarea id="napomenaPutniNalog" name="napomenaPutniNalog" value={formDataTripLog.napomenaPutniNalog} onChange={handleChange} rows={6} />
                            </div>
                         
                        </div>
                        <div className="gridPutniNalog">
                            <div className="col-12 md:col-6">
                                <label htmlFor="vozilo">{t('nova.vozilo')}:</label>
                                 <CustomDropdown
                                                                                        id="vozilo" 
                                                                                        name="vozilo" 
                                                                                        required
                                                                                        invalid={invalidControl(formDataTripLog.vozilo)} 
                                                                                        value={formDataTripLog.vozilo} 
                                                                                        options={vozilaOptions || []}
                                                                                        placeholder={t('nova.phVozilo')}
                                                                                        onChange={handleChange}
                                                                                        optionLabel="label"
                                                                                    />
                            </div>
                            <div className="col-12 md:col-6">
                                                    <div style={{display:'flex', justifyContent: 'space-between'}}>   
                                                        <h5 style={{ width: '85%', marginTop: '2%' }}>{t('ture.dodatnaVozila')}:</h5>
                                                        {porukaVozilo && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaVozilo}</p>}
                                                        <div style={{ marginTop: "0", width: "15%", padding: '1% 0 1% 0', scale: '0.7' }}>
                                                            <Button icon="pi pi-plus" type="button" onClick={addVehicle} className="p-button-success" />
                                                        </div>
                                                    </div>
                                                            
                                        <div className="redMiddle">
                                            {formDataTripLog.ostalaVozila.map((vozilo, index) => (
                                                <div key={index} className="red1 odgovornaLica">
                                                    <div className="col-12 md:col-6">
                                                        <div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
                                                            <div style={{ flex: '0 0 85%', marginTop: '2%', marginLeft: '2%' }}>
                                                                <label >{t('ture.dodatnoVozilo')}:</label>
                                                            </div>
                                                            <div style={{ marginTop: "0", flex: '0 0 15%', padding: '1% 0 1% 0', scale: '0.7', position: 'relative'}} className="col-12 md:col-6 flex align-items-end">
                                                                <Button
                                                                    icon="pi pi-minus"
                                                                    className="p-button-danger"
                                                                    type='button'
                                                                    onClick={() => removeVehicle(index)}
                                                                    disabled={formDataTripLog.ostalaVozila.length === 0}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <CustomDropdown
                                                            placeholder={t('ture.dodatnoVozilo')}
                                                            id={`ostalaVozila-${index}`}
                                                            name="ostalaVozila"
                                                            required 
                                                            optionLabel="label"
                                                            invalid={invalidControl(formDataTripLog.ostalaVozila)} 
                                                            value={vozilo}
                                                            options={zamenskaVozilaOptions}
                                                            onChange={(e) => handleChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                            </div>
                             <div className="col-12 md:col-6">
                                <label htmlFor="prikljucnoVozilo">{t('ture.prikljucnoVozilo')}:</label>
                                 <CustomDropdown
                                                                                        id="prikljucnoVozilo" 
                                                                                        name="prikljucnoVozilo" 
                                                                                        value={formDataTripLog.prikljucnoVozilo} 
                                                                                        options={prikljucnaVozilaOptions || []}
                                                                                        placeholder={t('ture.phPrikljucno')}
                                                                                        onChange={handleChange}
                                                                                        optionLabel="label"
                                                                                    />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="vozac">{t('ture.vozac')}:</label>
                                   <CustomDropdown
                                                                                        id="vozac" 
                                                                                        name="vozac" 
                                                                                        required
                                                                                        invalid={invalidControl(formDataTripLog.vozac)} 
                                                                                        value={formDataTripLog.vozac} 
                                                                                        options={vozaciOptions || []}
                                                                                        placeholder={t('ture.phVozaca')}
                                                                                        onChange={handleChange}
                                                                                        optionLabel="label"
                                                                                    />
                            </div>
                            <div className="col-12 md:col-6">
                                                    <div style={{display:'flex', justifyContent: 'space-between'}}>   
                                                        <h5 style={{ width: '85%', marginTop: '2%' }}>{t('ture.dodatniVozaci')}:</h5>
                                                        <div style={{ marginTop: "0", width: "15%", padding: '1% 0 1% 0', scale: '0.7' }}>
                                                            <Button icon="pi pi-plus" type="button" onClick={addDriver} className="p-button-success" />
                                                        </div>
                                                    </div>
                                                            
                                        <div className="redMiddle">
                                            {formDataTripLog.ostaliVozaci.map((vozac, index) => (
                                                <div key={index} className="red1 odgovornaLica">
                                                    <div className="col-12 md:col-6">
                                                        <div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
                                                            <div style={{ flex: '0 0 85%', marginTop: '2%', marginLeft: '2%' }}>
                                                                <label >{t('ture.vozac')}:</label>
                                                            </div>
                                                            <div style={{ marginTop: "0", flex: '0 0 15%', padding: '1% 0 1% 0', scale: '0.7', position: 'relative'}} className="col-12 md:col-6 flex align-items-end">
                                                                <Button
                                                                    icon="pi pi-minus"
                                                                    className="p-button-danger"
                                                                    type='button'
                                                                    onClick={() => removeDriver(index)}
                                                                    disabled={formDataTripLog.ostaliVozaci.length === 0}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <CustomDropdown
                                                            placeholder={t('ture.dodatniVozac')}
                                                            id={`ostaliVozaci-${index}`}
                                                            name="ostaliVozaci"
                                                            required
                                                            optionLabel="label"
                                                            invalid={invalidControl(formDataTripLog.ostaliVozaci)}
                                                            value={vozac}
                                                            options={vozaciZamenskiOptions}
                                                            onChange={(e) => handleChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="statusTure">{t('ture.statusTure')}:</label>
                                <Dropdown placeholder={t('ture.statusTure')}  id="statusTure" name="statusTure" value={formDataTripLog.statusTure} 
                                    options={statusTureOptions} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="obracunTure">{t('ture.obracunTure')}:</label>
                                <Dropdown placeholder={t('ture.obracunTure')} id="obracunTure" name="obracunTure" value={formDataTripLog.obracunTure} 
                                    options={obracunTureOptions} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumObracuna">{t('ture.datumObracuna')}:</label>
                                {porukaTimeRange2 && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange2}</p>}
                                <Calendar id="datumObracuna" name="datumObracuna" value={formDataTripLog.datumObracuna} mask="99.99.9999" onChange={handleChange} showIcon dateFormat="dd.mm.yy"/>
                            </div>
                        </div>

                        <div className="gridPutniNalog">
                            <div style={{display:'flex'}}>   
                                <Button id={changeView == 1 && activeClass} label={t('ture.vucno')} type="button" className="mt-3 putniNalogButtonsShift" onClick={()=> {setChangeView(1)} } />
                                <Button id={changeView == 2 && activeClass} label={t('ture.termoking')} type="button" className="mt-3 zaposleniShift" onClick={()=> {setChangeView(2)} } />
                                <Button id={changeView == 3 && activeClass}label={t('ture.adBlue')} type="button" className="mt-3 zaposleniShift" onClick={()=> {setChangeView(3)} } />    
                            </div>
                         
                        {changeView == 1 &&  <>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetnaKM">{t('ture.pocetnaKM')}:</label>
                                <InputNumber
                                    id="pocetnaKM" mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="pocetnaKM" value={formDataTripLog.pocetnaKM}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsnaKM">{t('ture.zavrsnaKM')}:</label>
                                <InputNumber
                                    id="zavrsnaKM" mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="zavrsnaKM" value={formDataTripLog.zavrsnaKM}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="razlikaKM">{t('ture.razlikaKM')}:</label>
                                <InputNumber
                                    id="razlikaKM" readOnly mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="razlikaKM" value={formDataTripLog.razlikaKM} inputClassName="poljeIzracunato"
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetnoStanjeGoriva">{t('ture.pocetnoGorivo')}:</label>
                                <InputNumber
                                    id="pocetnoStanjeGoriva" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="pocetnoStanjeGoriva" value={formDataTripLog.pocetnoStanjeGoriva}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsnoStanjeGoriva">Završno stanje goriva:</label>
                                <InputNumber
                                    id="zavrsnoStanjeGoriva" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="zavrsnoStanjeGoriva" value={formDataTripLog.zavrsnoStanjeGoriva}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="potrosenoGorivo">{t('ture.potrosenoGorivo')}:</label>
                                <InputNumber
                                    id="potrosenoGorivo" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="potrosenoGorivo" value={formDataTripLog.potrosenoGorivo}
                                    onValueChange={handleChange}
                                />
                            </div>
                             <div className="col-12 md:col-6"> 
                                <label htmlFor="prosecnaPotrosnja" style={{fontWeight: '600'}}>{t('ture.prosecnaPotrosnja')}:</label>
                                <InputNumber
                                    id="prosecnaPotrosnja" mode="decimal" suffix=" [l/100km]" minFractionDigits={1} maxFractionDigits={1}
                                    name="prosecnaPotrosnja" value={formDataTripLog.prosecnaPotrosnja}
                                    onValueChange={handleChange}
                                />
                            </div>

                        </>}
                        {changeView == 2 && <>
                               <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetniSatiTK">{t('ture.pocetniSatiDodatni')}:</label>
                                <InputNumber
                                    id="pocetniSatiTK" mode="decimal" suffix=" [h]" minFractionDigits={1} maxFractionDigits={1}
                                    name="pocetniSatiTK" value={formDataTripLog.pocetniSatiTK}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsniSatiTK">{t('ture.zavrsniSatiDodatni')}:</label>
                                <InputNumber
                                    id="zavrsniSatiTK" mode="decimal" suffix=" [h]" minFractionDigits={1} maxFractionDigits={1}
                                    name="zavrsniSatiTK" value={formDataTripLog.zavrsniSatiTK}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="razlikaSatiTK">{t('ture.razlikaSatiDodatni')}:</label>
                                <InputNumber
                                    id="razlikaSatiTK" readOnly mode="decimal" suffix=" [h]" minFractionDigits={1} maxFractionDigits={1}
                                    name="razlikaSatiTK" value={formDataTripLog.razlikaSatiTK} inputClassName="poljeIzracunato"
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetnoStanjeGorivaTK">{t('ture.pocetnoGorivoDodatni')}:</label>
                                <InputNumber
                                    id="pocetnoStanjeGorivaTK" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="pocetnoStanjeGorivaTK" value={formDataTripLog.pocetnoStanjeGorivaTK}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsnoStanjeGorivaTK">{t('ture.zavrsnoGorivoDodatni')}:</label>
                                <InputNumber
                                    id="zavrsnoStanjeGorivaTK" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="zavrsnoStanjeGorivaTK" value={formDataTripLog.zavrsnoStanjeGorivaTK}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="potrosenoGorivoTK" style={{fontWeight: '600'}}>{t('ture.potrosenoGorivoDodatni')}:</label>
                                <InputNumber
                                    id="potrosenoGorivoTK" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="potrosenoGorivoTK" value={formDataTripLog.potrosenoGorivoTK}
                                    onValueChange={handleChange}
                                />
                            </div>
                        </>}
                        {changeView == 3 &&  <>
                               <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetnaKMAdblue">{t('ture.pocetnaKMAdBlue')}:</label>
                                <InputNumber
                                    id="pocetnaKMAdblue" mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="pocetnaKMAdblue" value={formDataTripLog.pocetnaKMAdblue}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsnaKMAdblue">{t('ture.zavrsnaKMAdBlue')}:</label>
                                <InputNumber
                                    id="zavrsnaKMAdblue" mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="zavrsnaKMAdblue" value={formDataTripLog.zavrsnaKMAdblue}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="razlikaKMAdblue">{t('ture.razlikaKMAdBlue')}:</label>
                                <InputNumber
                                    id="razlikaKMAdblue" readOnly mode="decimal" suffix=" [km]" minFractionDigits={2} maxFractionDigits={2}
                                    name="razlikaKMAdblue" value={formDataTripLog.razlikaKMAdblue} inputClassName="poljeIzracunato"
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="pocetnoStanjeAdBlue">{t('ture.pocetnoStanjeAdBlue')}:</label>
                                <InputNumber
                                    id="pocetnoStanjeAdBlue" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="pocetnoStanjeAdBlue" value={formDataTripLog.pocetnoStanjeAdBlue}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="zavrsnoStanjeAdBlue">{t('ture.zavrsnoStanjeAdBlue')}:</label>
                                <InputNumber
                                    id="zavrsnoStanjeAdBlue" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="zavrsnoStanjeAdBlue" value={formDataTripLog.zavrsnoStanjeAdBlue}
                                    onValueChange={handleChange}
                                />
                            </div>
                            <div className="col-12 md:col-6"> 
                                <label htmlFor="potrosenAdBlue" style={{fontWeight: '600'}}>{t('ture.potrosenAdBlue')}:</label>
                                <InputNumber
                                    id="potrosenAdBlue" mode="decimal" suffix=" [l]" minFractionDigits={1} maxFractionDigits={1}
                                    name="potrosenAdBlue" value={formDataTripLog.potrosenAdBlue}
                                    onValueChange={handleChange}
                                />
                            </div>
                        </>}               
                        
                         
                        </div>
                    </Card>
                </div>
          
           
            {/* <button type='button' onClick={()=>{setOpenModal(true)}}>Otvori modal</button> */}
           <div className="formUnosZap buttonUnosZap">
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="btn btn-success"
              >
                {izabran ? 'SAČUVAJ' : 'UNOS' }
              </button>
            </div>
            </form>
        </div>
    );
};

export default PutniNalog;